import Vue from 'vue'
import Router from 'vue-router'
import auth from '../auth.js'

import LoginIndex from '@/pages/Login/Index.vue'
import Login from '@/pages/Login/Login.vue'
import Forgot from '@/pages/Login/Forgot.vue'
import ConfirmEmail from '@/pages/Login/ConfirmEmail.vue'
import Register from '@/pages/Login/Register.vue'
import RestorePassword from '@/pages/Login/RestorePassword.vue'
import CompleteInvite from '@/pages/Login/CompleteInvite.vue'

import HomeIndex from '@/pages/Home/Index.vue'
import Clients from '@/pages/Home/Clients/Clients.vue'
import Private from '@/pages/Home/Clients/Private.vue'
import Company from '@/pages/Home/Clients/Company.vue'
import CompanyEdit from '@/pages/Home/Clients/CompanyEdit.vue'
import AdAgentClient from '@/pages/Home/Clients/AdAgent.vue'
import Tasks from '@/pages/Home/Tasks.vue'
import TasksArchive from '@/pages/Home/TasksArchive.vue'
import CreateTaskManualy from '@/pages/Home/CreateTaskManualy.vue'
import ViewTask from '@/pages/Home/ViewTask.vue'
import Calculate from '@/pages/Home/Calculate/Calculate.vue'
import CalculateMachineSelect from '@/pages/Home/Calculate/CalculateMachineSelect.vue'
import CalculateProductSelect from '@/pages/Home/Calculate/CalculateProductSelect.vue'
import CalculatePrice from '@/pages/Home/Calculate/CalculatePrice.vue'
import Storage from '@/pages/Home/Storage.vue'
import Documents from '@/pages/Home/Documents.vue'

import Finance from '@/pages/Home/Finance/Index.vue'
import FinanceIncome from '@/pages/Home/Finance/FinanceIncome.vue'
import FinanceExpenses from '@/pages/Home/Finance/FinanceExpenses.vue'
import FinanceReports from '@/pages/Home/Finance/FinanceReports/Index.vue'
import FinanceReportsMenagers from '@/pages/Home/Finance/FinanceReports/FinanceReportsMenagers.vue'
import FinanceReportsClients from '@/pages/Home/Finance/FinanceReports/FinanceReportsClients.vue'
import FinanceReportsAccounts from '@/pages/Home/Finance/FinanceReports/FinanceReportsAccounts.vue'
import FinanceReportsProduction from '@/pages/Home/Finance/FinanceReports/FinanceReportsProduction.vue'
import DocumentEditor from '@/pages/Home/DocumentEditor.vue'

import SettingsIndex from '@/pages/Settings/SettingsIndex.vue'
import PersonalArea from '@/pages/Settings/PersonalArea.vue'
import Staff from '@/pages/Settings/Staff.vue'
import CompanyCard from '@/pages/Settings/CompanyCard.vue'
import Feedback from '@/pages/Settings/Feedback.vue'
import PersonalInformation from '@/pages/Settings/PersonalInformation.vue'
import PrintMachines from '@/pages/Settings/PrintMachines/Index.vue'
import PrintMachinesLoad from '@/pages/Settings/PrintMachines/PrintMachinesLoad.vue'
import PrintMachineCard from '@/pages/Settings/PrintMachines/PrintMachineCard.vue'
import PrintMachineOperations from '@/pages/Settings/PrintMachineOperations/Index.vue'
import OperationCard from '@/pages/Settings/PrintMachineOperations/OperationCard.vue'
import OperationTable from '@/pages/Settings/OperationTable.vue'
import PrintMachineProducts from '@/pages/Settings/PrintMachineProducts/Index.vue'
import ProductCard from '@/pages/Settings/PrintMachineProducts/ProductCard.vue'
import ProductSettings from '@/pages/Settings/PrintMachineProducts/ProductSettings.vue'
import FinanceSettigs from '@/pages/Settings/Finance/FinanceSettigs.vue'
import DocumentsSettings from '@/pages/Settings/DocumentsSettings/Index.vue'
import AddEditDocument from '@/pages/Settings/DocumentsSettings/AddEditDocument.vue'

import Admin from '@/pages/Admin/Index.vue'
import AdminCustomers from '@/pages/Admin/AdminCustomers.vue'
import AdminCompany from '@/pages/Admin/AdminCompany.vue'

import AdAgent from '@/pages/AdAgent/Index.vue'
import AddAgentTasks from '@/pages/AdAgent/Tasks/Index.vue'
import RequestCreate from '@/pages/AdAgent/Request/RequestCreate.vue'
import RequestView from '@/pages/AdAgent/Request/RequestView.vue'

import NotFound from '@/pages/Errors/Page404.vue'

Vue.use(Router)

const routes = [
  {
    path: '/',
    component: HomeIndex,
    beforeEnter: auth.requireAuth,
    children: [
      {
        path: '',
        component: Tasks
      },
      { path: '/tasks/incoming', component: AddAgentTasks, props: () => ({ status: 'incoming' }) },
      { path: '/tasks/archive', component: TasksArchive },
      {
        path: 'tasks/:status',
        component: Tasks,
        props: route => ({ status: route.params.status })
      },
      {
        path: 'add-task',
        component: CreateTaskManualy
      },
      {
        path: 'update-task/:taskId',
        component: CreateTaskManualy,
        props: route => ({ taskId: route.params.taskId, isUpdate: true })
      },
      {
        path: 'copy-task/:taskId',
        component: CreateTaskManualy,
        props: route => ({ taskId: route.params.taskId })
      },
      {
        path: 'add-task-from-calculator',
        component: CreateTaskManualy,
        props: route => ({ isFromCalculator: true, checkedCardItems: JSON.parse(route.query.checkedCardItems) })
      },
      {
        path: 'view-task/:taskId',
        component: ViewTask,
        props: route => ({ taskId: route.params.taskId })
      },
      {
        path: 'view-request/:requestId',
        component: RequestView,
        props: route => ({ requestId: route.params.requestId })
      },
      {
        path: 'clients',
        redirect: 'clients/private',
        component: Clients,
        children: [
          { path: 'private', component: Private },
          { path: 'company', component: Company },
          { path: 'ad-agent', component: AdAgentClient },
          { path: 'company/create', component: CompanyEdit },
          { path: 'company/edit/:id', component: CompanyEdit, props: true }
        ]
      },
      {
        path: 'finance',
        component: Finance,
        beforeEnter: auth.requireAuth,
        redirect: 'finance/income',
        children: [
          { path: 'income', component: FinanceIncome },
          { path: 'expenses', component: FinanceExpenses },
          {
            path: 'reports',
            component: FinanceReports,
            beforeEnter: auth.requireAuth,
            redirect: 'reports/managers',
            children: [
              { path: 'managers', component: FinanceReportsMenagers },
              { path: 'clients', component: FinanceReportsClients },
              { path: 'accounts', component: FinanceReportsAccounts },
              { path: 'production', component: FinanceReportsProduction }
            ]
          }
        ]
      },
      { path: '/document-editor/:id', component: DocumentEditor, props: true },
      {
        path: 'settings',
        component: SettingsIndex,
        beforeEnter: auth.requireAuth,
        children: [
          { path: '', component: Staff },
          { path: 'company-card', component: CompanyCard },
          { path: 'personal-area', component: PersonalArea },
          { path: 'feedback', component: Feedback },
          { path: 'personal-information', component: PersonalInformation },
          {
            path: 'print-machines',
            component: PrintMachines,
            children: [
              {
                path: 'card/:printMachineId',
                component: PrintMachineCard,
                props: true
              }
            ]
          },
          { path: 'print-machines/load', component: PrintMachinesLoad },
          {
            path: 'print-machine/:printMachineId/operation-table/:operationId',
            component: OperationTable,
            props: true
          },
          {
            path: 'print-machine-operations/:printMachineId',
            component: PrintMachineOperations,
            props: true,
            children: [
              {
                path: 'operation-card/:operationId',
                component: OperationCard,
                props: true
              }
            ]
          },
          {
            path: 'print-machine-products/:printMachineId',
            component: PrintMachineProducts,
            props: true,
            children: [
              {
                path: 'product-card/:productId',
                component: ProductCard,
                props: true
              }
            ]
          },
          {
            path: 'print-machine-products/:printMachineId/product-card/:productId/settings',
            component: ProductSettings,
            props: true
          },
          {
            path: 'finance',
            component: FinanceSettigs
          },
          {
            path: 'documents',
            component: DocumentsSettings
          },
          {
            path: 'documents/add',
            component: AddEditDocument
          },
          {
            path: 'documents/edit/:id',
            component: AddEditDocument,
            props: true
          }
        ]
      },
      {
        path: 'calculate',
        component: Calculate,
        children: [
          { path: '', component: CalculateMachineSelect },
          {
            path: 'machine-select',
            component: CalculateMachineSelect
          },
          {
            path: 'product-select/:printMachineId',
            component: CalculateProductSelect,
            props: true
          },
          {
            path: 'price/:printMachineId/:productId',
            component: CalculatePrice,
            props: true
          }
        ]
      },
      { path: 'storage', component: Storage },
      { path: 'documents', component: Documents }
    ]
  },
  {
    path: '/login',
    component: LoginIndex,
    children: [
      { path: '', component: Login },
      { path: 'register', component: Register },
      { path: 'forgot', component: Forgot },
      {
        path: 'restore-password/:token',
        component: RestorePassword,
        props: true
      },
      {
        path: 'complete-invite/:token',
        component: CompleteInvite,
        props: true
      },
      { path: 'confirm-email/:token', component: ConfirmEmail, props: true }
    ]
  },
  {
    path: '/admin',
    component: Admin,
    beforeEnter: auth.requireAuthAdmin,
    children: [
      { path: '', component: AdminCustomers },
      { path: 'company/:companyId', component: AdminCompany, props: true }
    ]
  },
  {
    path: '/ad-agent',
    component: AdAgent,
    redirect: '/ad-agent/tasks/accepted',
    beforeEnter: auth.requireAuthAdAgent,
    children: [
      { path: 'tasks/accepted', component: AddAgentTasks, props: () => ({ status: 'accepted' }) },
      { path: 'tasks/outgoing', component: AddAgentTasks, props: () => ({ status: 'outgoing' }) },
      { path: 'tasks/archived', component: TasksArchive },
      {
        path: 'calculate',
        component: Calculate,
        children: [
          { path: '', component: CalculateMachineSelect },
          {
            path: 'machine-select',
            component: CalculateMachineSelect
          },
          {
            path: 'product-select/:printMachineId',
            component: CalculateProductSelect,
            props: true
          },
          {
            path: 'price/:printMachineId/:productId',
            component: CalculatePrice,
            props: true
          }
        ]
      },
      {
        path: 'add-request',
        component: RequestCreate
      },
      {
        path: 'update-request/:requestId',
        component: RequestCreate,
        props: route => ({ requestId: route.params.requestId, isUpdate: true })
      },
      {
        path: 'add-request-from-calculator',
        component: RequestCreate,
        props: route => ({ isFromCalculator: true, checkedCardItems: JSON.parse(route.query.checkedCardItems) })
      },
      {
        path: 'view-request/:requestId',
        component: RequestView,
        props: route => ({ requestId: route.params.requestId })
      },
      {
        path: 'view-task/:taskId',
        component: ViewTask,
        props: route => ({ taskId: route.params.taskId })
      },
      { path: 'personal-information', component: PersonalInformation }
    ]
  },
  { path: '*', component: NotFound }
]

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: 'is-active'
})

export default router
